import { createContext } from '@lit/context';
export class RadioGroupContext {
    select(option) {
        this.selectListener?.(option);
    }
    add(option) {
        this.addListener?.(option);
    }
    remove(option) {
        this.removeListener?.(option);
    }
    onSelect(listener) {
        this.selectListener = listener;
    }
    onAdd(listener) {
        this.addListener = listener;
    }
    onRemove(listener) {
        this.removeListener = listener;
    }
}
export const radioGroupContext = createContext('radio-group');
export const radioGroupValueContext = createContext('radio-group-value');
export const radioGroupNameContext = createContext('radio-group-Name');
export const radioGroupAutocompleteContext = createContext('radio-group-Autocomplete');
export const radioGroupDisabledContext = createContext('radio-group-Disabled');
export const radioGroupReadonlyContext = createContext('radio-group-Readonly');
//# sourceMappingURL=radio-group-context.js.map